import { Component, OnInit } from '@angular/core';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Router} from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { AuthService } from "angularx-social-login";
import { SubscriptionService } from "../subscription/subscription.service";
import { environment } from '../../environments/environment';
import { AlertService } from "../components/alert/alert.service";
import { DamserviceService } from "../dam/damservice.service";

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

  currentUser: User;
  mobileView: boolean = false;
  isCustomPlan: boolean = false;
  radioYearly: boolean = true;
  mainSection: boolean = true;
  paymentSuccessSection: boolean = false;

  planName: String;
  ownerEmail: String;
  ownerName: String;

  selectedMembership: any = null;
  allowedInviteCount: any;
  addUserCount: any;
  totalPriceFixed: any;

  address: string = '128 santa rosa';
  city: string = 'San Francisco';
  state: string = 'CA';
  country: string = 'US';
  postcode: string = '94014';

  paymentProcessStyle = "none";
  strikeCheckout:any = null;
  userPic: any;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private authService: AuthService,
    private titleService: Title,
    private metaTagService: Meta,
    private subscriptionService: SubscriptionService,
    private alert: AlertService,
    private damService: DamserviceService,
  ) { }

  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;

    }

    this.titleService.setTitle("Subscribe a plan | Crafttor");
    this.metaTagService.addTags([
      { name: 'description', content: 'Subscription of plans is based on their storage space and invites.'},
      { name: 'keywords', content: 'pricing workspace, subscription workspace, checkout, workspace plan price, price plan' },
      { name: 'robots', content: 'index, follow' },
      { name: 'author', content: 'Crafttor' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { charset: 'UTF-8' }
    ]);

    if (this.currentUser) {
      this.getUserPic();
    } else {
      this.router.navigate(['/login']);
    }
  }

  showPayment(membership: any) {
    window.scrollTo(0, 0);
    if (this.currentUser) {
      this.titleService.setTitle("Checkout | Crafttor");
      this.selectedMembership = membership;
      this.addUserCount = this.selectedMembership.allowed_seats;
      this.allowedInviteCount = this.selectedMembership.allowed_seats;
      this.totalPriceFixed = (this.selectedMembership.price_yearly*12)*this.addUserCount;
    }
  }

  switchToWorkspace(){
    window.scrollTo(0, 0);
    // this.selectedMembershipBuyNow = membership;
    if (this.currentUser) {
      this.router.navigate(['/dam']);
    }
  }

  getUserPic() {
    this.damService.getUserPic().subscribe((data: any) => {
      this.userPic = data.user_pic;
    });
  }

  checkoutStripe(amount, currency, membership) {
    const strikeCheckout = (<any>window).StripeCheckout.configure({
      key: environment.STRIPE_LIVE_KEY,
      locale: 'auto',
      token: (stripeToken: any) => {
        this.paymentProcessStyle = "block";
        this.subscriptionService.postStripeOrder(stripeToken, amount, currency,
          membership.id, this.currentUser.firstName+" "+ this.currentUser.lastName,
          this.address, this.city, this.state, this.country, this.postcode,
          this.totalPriceFixed, this.addUserCount, this.isCustomPlan, "").subscribe((data) => {
          this.paymentProcessStyle = "none";
          this.paymentSuccessSection = true;
          this.mainSection = false;
        },
        (error) => {
          const errors = error.error || error.statusText;
          Object.keys(errors).map((key) => {
            errors[key].map((message) => {
              this.paymentProcessStyle = "none";
              this.alert.error(message);
            })
          })
       });
      }
    });

    strikeCheckout.open({
      name: 'Crafttor',
      description: 'Stripe Payment Gateway',
      image: 'https://crafttor.com/crafttor.jpg',
      currency: currency,
      amount: this.totalPriceFixed * 100
    });
  }

stripePaymentGateway() {
  if(!window.document.getElementById('stripe-script')) {
    const scr = window.document.createElement("script");
    scr.id = "stripe-script";
    scr.type = "text/javascript";
    scr.src = "https://checkout.stripe.com/checkout.js";

    scr.onload = () => {
      this.strikeCheckout = (<any>window).StripeCheckout.configure({
        key: environment.STRIPE_LIVE_KEY,
        locale: 'auto',
        token: function (token: any) {
        console.log(token)
        alert('Payment via stripe successfull!');
        }
      });
    }
    window.document.body.appendChild(scr);
    }
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  goToFeedback() {
    window.open("https://workspace.crafttor.com/feedbacks", "_blank");
  }

  goProClick() {
    this.router.navigate(['/dam/subscription']);
  }
}
